import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getCauseFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`causes.fields.Title`),
      columnHeader: t(`causes.columns.title`),
      allowAsConditionSource: true,
    },
    Significance: {
      fieldId: 'Significance',
      formLabel: t(`causes.fields.Significance`),
      columnHeader: t(`causes.columns.significance`),
      displayType: {
        displayType: 'rating',
        ratingKey: 'significance',
      },
      allowTargetConditions: true,
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`fields.Description`), // shared i18n
      columnHeader: t(`causes.columns.description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
  } as const satisfies FormConfig;
};
